import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex row grow g0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "loginbg",
  src: "/images/bg.jpg"
}, null, -1)
const _hoisted_3 = { class: "back-panel center" }
const _hoisted_4 = { class: "flex g24 align-center justify-center" }
const _hoisted_5 = { class: "flex col grow align-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  width: "150",
  src: "/ico/logo.svg"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: "/ico/label.svg" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginPanel = _resolveComponent("LoginPanel")!
  const _component_RegisterPanel = _resolveComponent("RegisterPanel")!
  const _component_LostPassword = _resolveComponent("LostPassword")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView(_ctx.LoginViewType.Login))),
            class: "logo flex col align-center",
            style: {"margin-bottom":"30px"}
          }, _hoisted_8),
          (_ctx.type == _ctx.LoginViewType.Login)
            ? (_openBlock(), _createBlock(_component_LoginPanel, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.type == _ctx.LoginViewType.Registration)
            ? (_openBlock(), _createBlock(_component_RegisterPanel, { key: 1 }))
            : _createCommentVNode("", true),
          (_ctx.type == _ctx.LoginViewType.LostPassword)
            ? (_openBlock(), _createBlock(_component_LostPassword, { key: 2 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}